export default "__VITE_ASSET__Cg8ZjXDD__"